import React from "react";
import { Button, Modal } from "react-bootstrap";

/**
 * Asks before Reset Values clears the form: a reset wipes every trace and
 * cannot be undone, and the button sits beside Edit and Create Trace where it
 * is easily hit by mistake.
 */
const ConfirmResetModal = ({ show, onCancel, onConfirm }) => (
  <Modal show={show} onHide={onCancel} centered>
    <Modal.Header closeButton>
      <Modal.Title>Reset all values?</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      This clears every input and removes all traces. It cannot be undone.
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onCancel}>
        Cancel
      </Button>
      <Button variant="danger" onClick={onConfirm}>
        Reset
      </Button>
    </Modal.Footer>
  </Modal>
);

export default ConfirmResetModal;
